import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {
  SignedIn,
  SignedOut,
  SignInButton,
  UserButton,
} from "@clerk/clerk-react";
import Home from "./pages/Home";
import ProjectDetail from "./pages/ProjectDetail";
import ActionItemsPage from "./pages/ActionItemsPage";

export default function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <header className="bg-white shadow-sm border-b">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <h1 className="text-xl font-semibold text-gray-900">Water</h1>
              <SignedIn>
                <UserButton />
              </SignedIn>
              <SignedOut>
                <SignInButton />
              </SignedOut>
            </div>
          </div>
        </header>

        <main>
          <SignedOut>
            <div className="max-w-md mx-auto mt-20 p-6 bg-white rounded-lg shadow-md">
              <h2 className="text-2xl font-bold text-center mb-6">Welcome</h2>
              <p className="text-gray-600 text-center mb-6">
                Please sign in to access your projects and action items.
              </p>
              <div className="flex justify-center">
                <SignInButton>
                  <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                    Sign In
                  </button>
                </SignInButton>
              </div>
            </div>
          </SignedOut>

          <SignedIn>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/project/:id" element={<ProjectDetail />} />
              <Route path="/action-items" element={<ActionItemsPage />} />
            </Routes>
          </SignedIn>
        </main>
      </div>
    </Router>
  );
}
